"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _CreatePage = _interopRequireDefault(require("./CreatePage"));
var _validations = require("./CreatePage/validations");
var _DraggableTree = _interopRequireDefault(require("./DraggableTree"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PagesTree = /*#__PURE__*/function (_React$Component) {
  function PagesTree(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PagesTree);
    _this = _callSuper(this, PagesTree, [props]);

    // eslint-disable-next-line react/state-in-constructor
    (0, _defineProperty2.default)(_this, "getPageURL", function (pagePath, nextProps) {
      var _ref = nextProps || _this.props,
        asset = _ref.asset,
        getPath = _ref.router.getPath,
        isDraft = _ref.isDraft,
        isEdit = _ref.isEdit;
      var params = _objectSpread(_objectSpread({}, asset), {}, {
        pagePath: pagePath
      });
      var name;
      if (isEdit) {
        name = 'pageEdit';
      } else if (isDraft) {
        name = 'pageDraft';
      } else {
        name = 'page';
      }
      return getPath(name, params);
    });
    /**
     * Get pages that are reorderable (excludes default pages, for example '/home')
     */
    (0, _defineProperty2.default)(_this, "getNonDefaultPages", function () {
      var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return pages.filter(function (page) {
        return !(0, _validations.isPredefinedPage)(page.name);
      }).map(function (page) {
        return {
          name: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            className: "visually-hidden"
          }, "Go to page "), /*#__PURE__*/_react.default.createElement("span", {
            "data-test-id": "editable-pages-tree-page-name"
          }, page.name)),
          path: page.path,
          url: _this.getPageURL(page.path, nextProps),
          title: page.name
        };
      });
    });
    (0, _defineProperty2.default)(_this, "handleOrderPages", function (orderedPages) {
      var _this$props = _this.props,
        onOrderPages = _this$props.onOrderPages,
        _this$props$asset = _this$props.asset,
        groupId = _this$props$asset.groupId,
        assetId = _this$props$asset.assetId,
        version = _this$props$asset.version,
        isDraft = _this$props.isDraft;
      _this.setState({
        pages: orderedPages
      });
      onOrderPages({
        groupId: groupId,
        assetId: assetId,
        version: version,
        pages: orderedPages,
        isDraft: isDraft
      });
    });
    _this.state = {
      pages: _this.getNonDefaultPages(props.pages)
    };
    return _this;
  }

  // eslint-disable-next-line camelcase
  (0, _inherits2.default)(PagesTree, _React$Component);
  return (0, _createClass2.default)(PagesTree, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        pages: this.getNonDefaultPages(nextProps.pages, nextProps)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        asset = _this$props2.asset,
        isEdit = _this$props2.isEdit,
        isDraft = _this$props2.isDraft,
        isContentLoading = _this$props2.isContentLoading,
        isSavingPagesOrder = _this$props2.isSavingPagesOrder;
      var pages = this.state.pages;
      return pages.length || isEdit && !isContentLoading ? /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "editable-pages-tree"
      }, isEdit ? /*#__PURE__*/_react.default.createElement(_DraggableTree.default, {
        items: pages,
        onOrderItems: this.handleOrderPages,
        isDragDisabled: isSavingPagesOrder
      }) : pages.map(function (page, index) {
        return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.SidebarItem, {
          to: page.url,
          title: page.title,
          key: "sidebar-item-".concat(index),
          isDisabled: page.isDisabled
        }, page.name);
      }), isEdit && !isContentLoading || isDraft ? /*#__PURE__*/_react.default.createElement(_CreatePage.default, {
        asset: asset,
        isDraft: true
      }) : null) : null;
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(PagesTree, "defaultProps", {
  router: {
    getPath: function getPath() {
      return '#';
    }
  }
});
var _default = exports.default = PagesTree;
//# sourceMappingURL=PagesTree.js.map